import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify); 

export default new Vuetify({
    theme: {
        themes: {
          light: {
            primary: '#3f51b5',
            navbarsbg:"#003d5e",
            sidebarbg:"#222222",
            secondary: '#b0bec5',
            accent: '#8c9eff',
            error: '#b71c1c',
            redText:'#cf1818',
            red:'#cf1818',
            epred:'#cf1818',
            epblue:'#1848cf',
            eporange:'#cf6418',
            epgreen:'#149943',
          },
        },
      },
});